export default __webpack_public_path__ + "static/media/bulkuploaditemssample.3568e2fd.xlsx";